var MAX_DOM_MOUNT_ATTEMPTS = 300;
var DOM_MOUNT_ATTEMPT_DELAY_MS = 50;
class WeeebflowCollection {
  constructor() {
    this.state = {
      height: 1000,
    };

    this.dom = {
      dWebCollectionPage: {
        selector: "[class*='collectPage'] > [class*='collectPage']",
        current: undefined,
      },
      mWebCollectionPage: {
        selector: "[role='content']",
        current: undefined,
      },
      iframeElement: {
        selector: "#weeebflow",
        current: undefined,
      },
    };

    this.config = {
      wrapperId: "--weeebflow-w",
      headerSelector: "#layout-header",
      headerHeightVar: "var(--navbar-height)",

      acceptedOrigins: [
        "https://www.sayweee.com",
        "https://tb1.sayweee.net",
        "https://tb2.sayweee.net",
      ],
    };

    this.DEBUG_VERBOSE = false;

    this.init();
  }

  injectStyles() {
    this.log("injectStyles(): fired");

    let documentHead = document.getElementsByTagName("head")[0];
    let customStyles = document.createElement("style");
    let wrapperSelector = `[data-wf='${this.config.wrapperId}']`;
    let { headerSelector, headerHeightVar } = this.config;

    let customCss = `
      @import url('https://fonts.googleapis.com/css2?family=Be+Vietnam+Pro:wght@400;500;600;700&family=Noto+Sans+JP:wght@400;500;700&family=Noto+Sans+KR:wght@400;500;700&family=Noto+Sans+SC:wght@400;500;700&display=swap');

      ${this.dom.iframeElement.selector} {
        opacity: 1 !important;
      }

      ${wrapperSelector} > *:not(iframe):not(#mainContent):not([class*="collect_contents"]),
      ${wrapperSelector} > [class*="collect_contents"] > *:not(iframe):not(#mainContent) {
        display: none;
      }

      ${wrapperSelector} > [class*="collect_contents"],
      ${wrapperSelector} #mainContent,
      ${wrapperSelector} #mainContent p {
        width: 100%;
        max-width: 100%;

        margin: 0;
        padding: 0;

        display: block;

        min-height: 100vh;
      }

      ${wrapperSelector} #mainContent iframe {
        width: 100%;
        min-height: 100vh;

        outline: unset;
        border: unset;
      }

      ${wrapperSelector} > [class*="collectContainer"] {
        padding: 0;
      }

      @media (hover: none) {
        ${headerSelector} {
          margin-bottom: calc(${headerHeightVar} * -1);
        }

        ${headerSelector} [class*="collect_headerBox"] {
          padding-bottom: 5px;
        }

        ${headerSelector} [class*="collect_title"] {
          display: none;
        }

        ${headerSelector} [class*="collect_withBackground"] {
          background: white;

          box-shadow: 0px 10px 15px rgba(0,0,0, .06);
        }
      }
    `;

    customStyles.innerHTML = customCss;

    if (this.dom.dWebCollectionPage.current) {
      this.dom.dWebCollectionPage.current.setAttribute(
        "style",
        `margin: 0 !important; width: auto !important; max-width: unset !important;`
      );

      this.dom.dWebCollectionPage.current.setAttribute(
        "data-wf",
        this.config.wrapperId
      );
    }

    if (this.dom.mWebCollectionPage.current) {
      this.dom.mWebCollectionPage.current.setAttribute(
        "data-wf",
        this.config.wrapperId
      );
    }

    documentHead.appendChild(customStyles);
  }

  updateIframeHeight(height) {
    this.log("updateIframeHeight() fired", height);

    try {
      if (this.dom.iframeElement.current && !this.dom.iframeElement.current.isConnected) {
        const newIframe = window.document.querySelectorAll(`iframe${this.dom.iframeElement.selector}`)[0]
        if (newIframe && newIframe.isConnected) {
          this.dom.iframeElement.current = newIframe
        }
      }
    } catch (e) {
      console.error(`[collection]_updateIframeHeight error:`, e)
    }

    this.dom.iframeElement.current.setAttribute(
      "style",
      `height: ${height}px;`
    );
  }

  setWindowHref(href) {
    this.log("setWindowHref() fired");

    // window.scrollTo(0, 0);
    window.location.href = href;
  }

  postMessageEventListener() {
    this.log("postMessageEventListener() fired");

    let _self = this;

    window.addEventListener(
      "message",
      (event) => {
        this.log("postMessageEventListener() payload", event);

        if (!event.data) return;
        if (!this.config.acceptedOrigins.includes(event.origin)) return;

        this.log("postMessageEventListener() origin accepted", event.origin);

        if (event.data.contentHeight) {
          this.updateIframeHeight(event.data.contentHeight);
        }

        if (event.data.setWindowHref) {
          this.setWindowHref(event.data.setWindowHref);
        }

        this.log("postMessageEventListener():", event);
      },
      false
    );
  }

  createDOM() {
    this.log("createDOM() fired");

    let dWebCollectionPage = document.querySelector(
      this.dom.dWebCollectionPage.selector
    );

    let mWebCollectionPage = document.querySelector(
      this.dom.mWebCollectionPage.selector
    );

    let iframeElement = document.querySelector(this.dom.iframeElement.selector);

    if (dWebCollectionPage) {
      this.dom.dWebCollectionPage.current = dWebCollectionPage;

      this.log("dWebCollectionPage found", this.dom.dWebCollectionPage.current);

      this.injectStyles();
    }

    if (mWebCollectionPage) {
      this.dom.mWebCollectionPage.current = mWebCollectionPage;

      this.log("mWebCollectionPage found", this.dom.mWebCollectionPage.current);

      this.injectStyles();
    }

    if (iframeElement) {
      this.dom.iframeElement.current = iframeElement;

      this.log("iframeElement found", this.dom.iframeElement.current);

      this.postMessageEventListener();
    }
  }

  /**
   * @name Logger
   */
  log(msg, extras = " ", isError = false) {
    if (!this.DEBUG_VERBOSE) return;

    if (!isError) {
      console.log(`WeeebflowCollection(): ${msg}`, extras);
    } else {
      console.error(`WeeebflowCollection(): ${msg}`, extras);
    }
  }

  init() {
    let didFindElement;

    try {
      let iframeElement = document.querySelector(
        this.dom.iframeElement.selector
      );
      if (iframeElement) {
        didFindElement = true;
      }
    } catch (e) {
      console.error(
        `[WeeebflowCollection]_failedTo_init checking iframe error. Error:`,
        e
      );
    }

    if (didFindElement) {
      if (!window.__weeebflowCollectionVars)
        window.__weeebflowCollectionVars = {};
      window.__weeebflowCollectionVars.mountDOMattemptsCount = 0;

      this.createDOM();
    } else {
      if (typeof window != "undefined") {
        if (!window.__weeebflowCollectionVars)
          window.__weeebflowCollectionVars = {};
        const mountDOMattemptsCount =
          window.__weeebflowCollectionVars.mountDOMattemptsCount || 0;

        if (mountDOMattemptsCount <= MAX_DOM_MOUNT_ATTEMPTS) {
          console.info(
            `[WeeebflowCollection]_failedTo_init checking iframe not YET found. Will try again. mountDOMattemptsCount[${mountDOMattemptsCount}] MAX_DOM_MOUNT_ATTEMPTS[${MAX_DOM_MOUNT_ATTEMPTS}] DOM_MOUNT_ATTEMPT_DELAY_MS[${DOM_MOUNT_ATTEMPT_DELAY_MS}]`
          );

          window.__weeebflowCollectionVars.mountDOMattemptsCount =
            mountDOMattemptsCount + 1;
          setTimeout(() => {
            this.init();
          }, DOM_MOUNT_ATTEMPT_DELAY_MS);
        } else {
          console.error(
            `[WeeebflowCollection]_failedTo_init checking iframe never found. mountDOMattemptsCount[${mountDOMattemptsCount}] MAX_DOM_MOUNT_ATTEMPTS[${MAX_DOM_MOUNT_ATTEMPTS}] DOM_MOUNT_ATTEMPT_DELAY_MS[${DOM_MOUNT_ATTEMPT_DELAY_MS}]`
          );
        }
      }
    }
  }
}

module.exports = { WeeebflowCollection };
